import React from "react";

import Seek2 from "../ResourcesProjects/UploadPhotosToWeb/seek/Seek-1-2.png"
import Seek1 from "../ResourcesProjects/UploadPhotosToWeb/seek/Seek-1-1.png"

const SeekLogo = () => {
return (
        <div id="seekLogoContainer">
            <img src={Seek2} alt="seek logo layer" id="seekPhoto17" className="seekLogo"></img>
            <img src={Seek1} alt="seek logo layer" id="seekPhoto19" className="seekLogo"></img>
        </div>
)
}
export default SeekLogo;